import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardService } from '@teem/services/dashboard.service';
import { ProductService } from '@teem/services/product.service';
import { LoaderService } from '@teem/services/loader.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { EditProductComponent } from '@teem/product-module/modals/edit-product/edit-product.component';
import Swal from 'sweetalert2';
import { ACTIONS as PRODUCT_ACTIONS } from '@teem/constants/product';
import { messages as i18n } from '@teem/constants/messages';
import { SharedDataService } from '@teem/services/shared-data.service';
import { Product } from '@teem/models/product';

@Component({
	selector: 'recently-added',
	templateUrl: './recently-added-products.component.html',
	styleUrls: ['./recently-added-products.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class RecentlyAddedProductsComponent implements OnInit {
	@Output() onEditProduct: EventEmitter<any> = new EventEmitter();
	product: any = {};
	constructor(
		private dashboardService: DashboardService,
		private productService: ProductService,
		private loaderService: LoaderService,
		private sharedDataService: SharedDataService,
		private modalService: NgbModal
	) {

	}

	products: any = [];
	storeType: string = '';


	// products = [
	// 	{ active: true, stock: false, name: 'test', net_price: '50', description: 'Lorem ipsum dolor sit amet consectetur. Tincidunt imperdiet erat' },
	// 	{ active: true, stock: true, name: 'test2', net_price: '50', description: 'Lorem ipsum dolor sit amet consectetur. Tincidunt imperdiet erat' },
	// 	{ active: false, stock: false, name: 'test3', net_price: '50', description: 'Lorem ipsum dolor sit amet consectetur. Tincidunt imperdiet erat' },
	// 	{ active: true, stock: true, name: 'test4', net_price: '50', description: 'Lorem ipsum dolor sit amet consectetur. Tincidunt imperdiet erat' },
	// 	{ active: true, stock: true, name: 'test5', net_price: '50', description: 'Lorem ipsum dolor sit amet consectetur. Tincidunt imperdiet erat' },
	// ]

	showHideProduct(product: any, key: string, type: 'status-update' | 'stock-status') {
		console.log(type);
		this.productService.action({ 'do': type, 'ids': [product.uuid] }).subscribe(
			response => {
				console.log(response);
			},
			err => {
				console.error(err);
			}
		);

		product[key] = !product[key];
	}

	// showHideActions(i, j) {
	// 	$('.options-menu').addClass('d-none');
	// 	$('.options-menu-' + i + '-' + j).removeClass('d-none');
	// }
	showHideActions(i, j) {
		const currentMenu = $('.options-menu-' + i + '-' + j);
		const isCurrentlyHidden = currentMenu.hasClass('d-none');
		$('.options-menu').addClass('d-none');

		if (isCurrentlyHidden) {
			currentMenu.removeClass('d-none');
		}
	}

	// recentProducts
	ngOnInit(): void {
		this.getRecentProducts();
	}

	getRecentProducts() {
		this.products = [];
		this.dashboardService.getRecentProducts().subscribe((response: any = []) => {
			this.products = response.products;
			this.storeType = response.business_type;

		});
	}

	statusUpdateProduct(product: any, key: string) {
		this.loaderService.startLoading();

		this.productService.action({ 'do': 'status-update', 'ids': [product.uuid] }).subscribe(product => {
			console.log(product)

		}, err => {

		});
		this.loaderService.stopLoading();
		product[key] = !product[key];

	}

	stockUpdateProduct(product: any, key: string) {
		this.loaderService.startLoading();

		this.productService.action({ 'do': 'stock-status', 'ids': [product.uuid] }).subscribe(product => {
			console.log(product)
		}, err => {

		});
		this.loaderService.stopLoading();
		product[key] = !product[key];
	}

	confirmDelete(product: any) {
		if (product.uuid) {
			Swal.fire({
				title: i18n.are_you_sure,
				text: i18n.product.you_want_to_delete_product,
				// icon: 'info',
				showCloseButton: true,
				showCancelButton: true,
				focusConfirm: false,
				confirmButtonColor: "#EB1461",
				confirmButtonText: i18n.delete,
				cancelButtonText: i18n.no_cancel_it,
				customClass: { cancelButton: 'custom_swal_cancel' }
			}).then(result => {
				if (result.value) {
					this.loaderService.startLoading();

					this.productService.action({ 'do': PRODUCT_ACTIONS.DELETE, 'ids': [product.uuid] }).subscribe(data => {
						this.getRecentProducts();
						this.loaderService.stopLoading();
						Swal.fire(i18n.deleted, i18n.product.deleted, 'success');
					}, err => {
						this.loaderService.stopLoading();
						Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
					});
				}
			});
		}
	}

	editProduct(product: any) {
		this.loaderService.startLoading();
		this.productService.get(product.uuid).subscribe(product => {
			this.product = product;
			this.openEditProductModal();
			this.loaderService.stopLoading();
		}, err => {
			this.loaderService.stopLoading();
		})
	}

	openEditProductModal() {
		let modalRef = this.modalService.open(EditProductComponent);
		modalRef.componentInstance.productInfo = this.product;

		const parentElement = modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement;
		parentElement.id = "add-product-service";
		parentElement.classList.add("new-product-service");

		modalRef.result.then(
			onfulfilled => {
				this.onEditProduct.emit();
				this.getRecentProducts();
			},
			onrejected => {

			}
		);
	}

	onImgError(product: any) {
		product.product_image = 'images/no-image.png';
	}
}
